// @generated-imports
import { escapeHTML } from './app.js';
import { dom, state } from './core.js';
import { gpShortName } from './gamepad.js';
import { layerClosed, layerOpened } from './layers.js';
import { getSetting } from './platform.js';
// @generated-imports
/* ===========================================================================
   JOGAR EM DOIS (v2.0)
   ---------------------------------------------------------------------------
   Metadados `players`, `coop` e `modes` (coop / versus / simultaneous /
   alternating) viram filtro; antes de um jogo multiplayer com dois ou mais
   controles conectados, a tela "Quem é o jogador 1?" identifica cada pad
   pelo botão apertado e testa os botões — a ordem vai ao emulador pelo
   adaptador (detecção de capacidade; sem suporte, orienta pelo menu).
   ======================================================================== */

const PLAYERS_FILTERS = {
  all: () => true,
  solo: (game) => (game.players || 1) === 1,
  two: (game) => (game.players || 1) >= 2,
  coop: (game) => Boolean(game.coop) || (game.modes || []).includes('coop'),
  versus: (game) => (game.modes || []).includes('versus'),
  simultaneous: (game) => (game.modes || []).includes('simultaneous'),
  alternating: (game) => (game.modes || []).includes('alternating'),
};

function matchesPlayersFilter(game) {
  const test = PLAYERS_FILTERS[state.playersFilter] || PLAYERS_FILTERS.all;
  return test(game);
}

function connectedPads() {
  try {
    return navigator.getGamepads ? [...navigator.getGamepads()].filter(Boolean) : [];
  } catch (_) { return []; }
}

/** Formato de identidade que o EmulatorJS usa em gamepadSelection. */
function padSelectionId(pad) {
  return `${pad.id}_${pad.index}`;
}

/** Deve perguntar quem é P1/P2 antes de iniciar? */
function shouldAskPlayerOrder(game) {
  if (!getSetting('askPlayerOrder')) return false;
  if (!game || (game.players || 1) < 2) return false;
  return connectedPads().length >= 2;
}

/** Abre a tela de identificação; resolve com a ordem [idP1, idP2] ou null. */
function openPlayerAssignment(game) {
  return new Promise((resolve) => {
    if (!dom.playersModal) { resolve(null); return; }
    const pads = connectedPads();
    // 2 a 4 jogadores: limitado pelo jogo e pelos controles conectados.
    const need = Math.max(2, Math.min(4, (game && game.players) || 2, pads.length || 2));
    const assignment = [];
    let finished = false;
    let raf = 0;
    const prev = new Map();

    const finish = (order) => {
      if (finished) return;
      finished = true;
      window.cancelAnimationFrame(raf);
      dom.playersModal.classList.add('is-hidden');
      layerClosed('players');
      resolve(order);
    };
    state.playersModalFinish = finish;

    const render = () => {
      const step = assignment.length + 1;
      dom.playersTitle.textContent = step === 1 ? '🎮 Quem é o jogador 1?' : step <= need ? `🎮 E o jogador ${step}?` : 'Controles definidos';
      dom.playersHint.textContent = step <= need
        ? `Aperte qualquer botão no controle que será este jogador.${step > 2 ? ' Ou confirme para jogar com menos.' : ''}`
        : 'Pronto! Teste os botões e confirme.';
      dom.playersList.innerHTML = pads.map((pad) => {
        const slot = assignment.indexOf(padSelectionId(pad));
        const badge = slot >= 0 ? `<span class="player-badge">P${slot + 1}</span>` : '';
        return `<div class="backup-row data-row"><span class="data-info">${badge} ${escapeHTML(gpShortName(pad.id))} <small data-pad-test="${pad.index}">aguardando botão…</small></span></div>`;
      }).join('') || '<div class="backup-row">Nenhum controle detectado. Conecte e aperte um botão.</div>';
      dom.playersConfirm.disabled = assignment.length < 2;
    };

    const poll = () => {
      if (finished) return;
      raf = window.requestAnimationFrame(poll);
      const current = connectedPads();
      current.forEach((pad) => {
        const pressed = pad.buttons.findIndex((b) => b && (b.pressed || b.value > 0.5));
        const key = padSelectionId(pad);
        const was = prev.get(key);
        prev.set(key, pressed);
        const label = dom.playersList.querySelector(`[data-pad-test="${pad.index}"]`);
        if (pressed >= 0 && label) label.textContent = `botão ${pressed} apertado`;
        if (pressed >= 0 && (was === undefined || was < 0) && assignment.length < need && !assignment.includes(key)) {
          assignment.push(key);
          render();
        }
      });
    };

    render();
    dom.playersModal.classList.remove('is-hidden');
    layerOpened('players', dom.playersConfirm);
    dom.playersConfirm.onclick = () => finish(assignment.slice(0, need));
    dom.playersSkip.onclick = () => finish(null);
    poll();
  });
}

function closePlayersModal() {
  if (state.playersModalFinish) state.playersModalFinish(null);
}

// @generated-exports
export { PLAYERS_FILTERS, closePlayersModal, connectedPads, matchesPlayersFilter, openPlayerAssignment, padSelectionId, shouldAskPlayerOrder };
// @generated-exports
